import Phaser from 'phaser'
import { BootScene } from './scenes/BootScene'
import { MenuScene } from './scenes/MenuScene'
import { LobbyScene } from './scenes/LobbyScene'
import { GameScene } from './scenes/GameScene'
import { GameOverScene } from './scenes/GameOverScene'

// Detect mobile by screen size - phones typically have width < 768 in portrait
const isMobileScreen = window.innerWidth < 768 ||
                       (window.innerWidth < 1024 && window.innerHeight < window.innerWidth * 0.7)

// Use smaller resolution on mobile for larger UI elements
const gameWidth = isMobileScreen ? 800 : 1280
const gameHeight = isMobileScreen ? 600 : 720

// Export for scenes to use
export const IS_MOBILE = isMobileScreen

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  parent: 'game-container',
  width: gameWidth,
  height: gameHeight,
  backgroundColor: 0x0a0a15,
  scene: [BootScene, MenuScene, LobbyScene, GameScene, GameOverScene],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    expandParent: true
  },
  render: {
    pixelArt: false,
    antialias: false,
    roundPixels: true
  },
  input: {
    activePointers: 3,
    touch: {
      capture: true
    }
  }
}

new Phaser.Game(config)
